import assert from 'assert';

import { api } from './api';
import { isPermissionRole } from '../../utilities/roleUtility';

function _userinfo() {
  this._debug = false;

  this._field_id = 0;
  this._field_name = '';
  this._user_type = '';
  this._user_name = '';
  this._user_id = 0;
  this._company_branch_id = 0;

  this.init = async function({
    field_id,
    field_name,
    user_id,
    user_name,
    user_type,
    company_id,
  }) {
    var self = this;
    self._field_id = String(field_id);
    self._field_name = String(field_name);
    self._user_type = String(user_type);
    self._user_name = String(user_name);
    self._user_id = String(user_id);
    self._company_branch_id = String(company_id);

    assert(
      isPermissionRole(self._user_type),
      `userinfo getUserType:${self._user_type}`
    );

    // ユーザー情報設定
    const userProfilesRes = await api.getUserProfiles();
    var user_profile = userProfilesRes.data.entities.user_profile;
    var company = userProfilesRes.data.entities.company;
    self._user_name = `${user_profile.name_sei} ${user_profile.name_mei}`;
    self._user_company_name = String(company[0].name);

    // 現場情報設定
    const fieldInfoRes = await api.getFieldInfo(self._field_id);
    var field = fieldInfoRes.data.entities.field;
    self._field_name = field.name;
    self._company_branch_id = String(field.company.company_branch_id);
  };

  this.getFieldId = function() {
    return this._field_id;
  };

  this.getFieldName = function() {
    return this._field_name;
  };

  this.getUserType = function() {
    return this._user_type;
  };

  this.getUserName = function() {
    return this._user_name;
  };

  this.getUserId = function() {
    return this._user_id;
  };

  this.getCompanyBranchId = function() {
    return this._company_branch_id;
  };

  this.getUserCompanyName = function() {
    return this._user_company_name;
  };
}

export const userinfo = new _userinfo();



// WEBPACK FOOTER //
// ./src/canvas/common/userinfo.js